import React from 'react';
import { currentRoles, numbers, services } from '../data/practice';
export function Practice() {
  return <section id="practice" className="border-b border-rule" data-id="element-60" data-mp="18mzcf1za8spo">
      <div className="mx-auto max-w-page px-6 py-20 lg:px-10 lg:py-28" data-id="element-61" data-mp="1dmu6tfi9o0fh">
        <div className="grid gap-8 lg:grid-cols-12" data-id="element-62" data-mp="1dnn2nlfot5iu">
          <div className="lg:col-span-4" data-id="element-63" data-mp="1im6s3vthozfy">
            <p className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-64" data-mp="1il5epkp040v2">
              The day job
            </p>
            <h2 className="mt-6 font-serif text-[clamp(2rem,4vw,3.25rem)] leading-[1.02] tracking-[-0.02em] text-ink" data-id="element-65" data-mp="px9c5zcr3eqd">
              Advice, not products
            </h2>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-66" data-mp="uuj69sb34ekj">
            <p className="font-sans text-[17px] leading-[1.7] text-ink-soft" data-id="element-67" data-mp="znuiya2kvpkd">
              I work as a SEBI Registered Investment Advisor and Certified Financial Planner.
              That means I am paid by the client and no one else, and the work is the whole
              picture rather than a single product.
            </p>
            <ul className="mt-8 flex flex-wrap gap-x-3 gap-y-3" data-id="element-68" data-mp="3m7pxng71w937">
              {services.map(service => <li key={service} className="border border-rule px-3 py-[6px] font-sans text-[13px] text-ink" data-id="element-69" data-mp="3h8va60y51wcr">
                  {service}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 grid gap-x-8 gap-y-10 border-t border-rule pt-10 lg:grid-cols-12" data-id="element-70" data-mp="33gfbfcc9skhn">
          {currentRoles.map(role => <article key={role.id} className="flex flex-col lg:col-span-6" data-id="element-71" data-mp="2tgoel408ltee">
              <header data-id="element-72" data-mp="2tirfij2xh6xw">
                <h3 className="font-serif text-[26px] leading-none text-ink" data-id="element-73" data-mp="2pfmeym2erfbw">{role.company}</h3>
                <p className="mt-3 font-sans text-[14px] font-medium text-ink" data-id="element-74" data-mp="rpbb8jdx3tkg">{role.title}</p>
                <p className="mt-1 font-sans text-[13px] tabular-nums text-muted" data-id="element-75" data-mp="no9b80c6fdhf">
                  {role.years} · {role.place}
                </p>
              </header>

              <p className="mt-5 font-sans text-[15px] leading-[1.6] text-ink" data-id="element-76" data-mp="2h4m18p436qeb">{role.summary}</p>

              <ul className="mt-4 space-y-3 border-t border-rule pt-4" data-id="element-77" data-mp="2lzi5qoqif68b">
                {role.points.map(point => <li key={point.slice(0, 28)} className="font-sans text-[14px] leading-[1.6] text-ink-soft" data-id="element-78" data-mp="2c7lwqimvxvpb">
                    {point}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-16 border-t border-rule pt-8" data-id="element-79" data-mp="2qwi9uu3styws">
          <p className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-80" data-mp="2qw0avppr56l6">
            Leading investments at Liquide, 2023 — 2025
          </p>
          <dl className="mt-8 grid grid-cols-2 gap-x-8 gap-y-8 lg:grid-cols-4" data-id="element-81" data-mp="1fgtou8a3v9ym">
            {numbers.map(item => <div key={item.label} data-id="element-82" data-mp="1khhbyiv7r6nk">
                <dt className="sr-only" data-id="element-83" data-mp="1ked3h9aptor3">{item.label}</dt>
                <dd data-id="element-84" data-mp="1bye5bdylr053">
                  <span className="block font-serif text-[clamp(2rem,3.5vw,3rem)] leading-none tracking-[-0.02em] text-ink" data-id="element-85" data-mp="1bxul1qlhbznw">
                    {item.value}
                  </span>
                  <span className="mt-3 block max-w-[22ch] font-sans text-[13px] leading-[1.5] text-muted" data-id="element-86" data-mp="1lwadbww8teyz">
                    {item.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}